import styled from 'styled-components';

export const StyledChatPage = styled('div')``;
